import React, { useEffect, useState, useCallback, useRef, } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  ChartOfAccountsSelect
} from "../common/APICommon";
import { apiUrl } from "../utils/Configuration";
import NoAccess from "./NoAccess";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { motion, AnimatePresence } from "framer-motion";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InventoryIcon from '@mui/icons-material/Inventory';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import PublishIcon from '@mui/icons-material/Publish';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PreviewIcon from '@mui/icons-material/Preview';

export default function Items() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.itemCode.toLowerCase().includes(lowerValue) ||
        item.itemDescription.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [itemCode, setItemCode] = useState("");
  const [itemDescription, setItemDescription] = useState("");
  const [uomName, setUomName] = useState("");
  const [purchaseUomName, setPurchaseUomName] = useState("");
  const [salesUomName, setSalesUomName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [salesAccount, setSalesAccount] = useState(null);
  const [salesReturnAccount, setSalesReturnAccount] = useState(null);
  const [salesDiscountAccount, setSalesDiscountAccount] = useState(null);
  const [costOfGoodsAccount, setCostOfGoodsAccount] = useState(null);
  const [inventoryAccount, setInventoryAccount] = useState(null);
  const [purchaseAccount, setPurchaseAccount] = useState(null);

  const resetVariables = () => {
    setItemCode("");
    setItemDescription("");
    setUomName("");
    setPurchaseUomName("");
    setSalesUomName("");
    setBrandName("");
    setCategoryName("");
    setSalesAccount(null);
    setSalesReturnAccount(null);
    setSalesDiscountAccount(null);
    setCostOfGoodsAccount(null);
    setInventoryAccount(null);
    setPurchaseAccount(null);
    setSelectedData(null);
  }
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      itemCode: itemCode,
      itemDescription: itemDescription,
      uomName: uomName,
      purchaseUomName: purchaseUomName,
      salesUomName: salesUomName,
      brandName: brandName,
      categoryName: categoryName,
      salesAccountId: salesAccount?.id,
      salesReturnAccountId: salesReturnAccount?.id,
      salesDiscountAccountId: salesDiscountAccount?.id,
      costOfGoodsAccountId: costOfGoodsAccount?.id,
      inventoryAccountId: inventoryAccount?.id,
      purchaseAccountId: purchaseAccount?.id
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Item`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Item/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  }, []);

  const editHandleClick = async (_data) => {
    setLoading(true);

    const itemData = await fetchDataById(_data)
    setSelectedData(itemData);

    setItemCode(itemData.itemCode);
    setItemDescription(itemData.itemDescription);
    setUomName(itemData.uomName);
    setPurchaseUomName(itemData.purchaseUomName);
    setSalesUomName(itemData.salesUomName);
    setBrandName(itemData.brandName);
    setCategoryName(itemData.categoryName);
    setSalesAccount(itemData.salesAccount);
    setSalesReturnAccount(itemData.salesReturnAccount);
    setSalesDiscountAccount(itemData.salesDiscountAccount);
    setCostOfGoodsAccount(itemData.costOfGoodsAccount);
    setInventoryAccount(itemData.inventoryAccount);
    setPurchaseAccount(itemData.purchaseAccount);

    openUpdateForm();
    setLoading(false);
  }

  const handleUpdateData = async () => {
    const data = {
      itemCode: itemCode,
      itemDescription: itemDescription,
      uomName: uomName,
      purchaseUomName: purchaseUomName,
      salesUomName: salesUomName,
      brandName: brandName,
      categoryName: categoryName,
      salesAccountId: salesAccount?.id,
      salesReturnAccountId: salesReturnAccount?.id,
      salesDiscountAccountId: salesDiscountAccount?.id,
      costOfGoodsAccountId: costOfGoodsAccount?.id,
      inventoryAccountId: inventoryAccount?.id,
      purchaseAccountId: purchaseAccount?.id
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/Item/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'CODE', 
    'DESCRIPTION', 
    'UNIT OF MEASUREMENT', 
    'BRAND', 
    'CATEGORY', 
    'ACCOUNTS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'itemCode', 
    'itemDescription', 
    'uomName', 
    'brandName', 
    'categoryName', 
    'accounts', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Item` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion

  const [showImportForm, setShowImportForm] = useState(false)

  const openImportForm = () => {
    setShowImportForm(true);
  }
  const closeImportForm = () => {
    setShowImportForm(false);
  }

  const fetchAccountsData = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/GLAccount` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return
    }
  }, []);
  
  const handleExport = async () => {
    setLoading(true);

    try {
      const accountsData = await fetchAccountsData();
      
      // Sort account names alphabetically (Required for the search formula to work cleanly)
      const accountNames = accountsData
        .map(acc => acc.accountName)
        .filter(name => !!name)
        .sort((a, b) => a.localeCompare(b));

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Items List');
      
      // 1. Create a hidden sheet to store the dropdown values
      const sourceSheet = workbook.addWorksheet('Account_Data', { state: 'hidden' });
      accountNames.forEach((name, index) => {
        sourceSheet.getCell(index + 1, 1).value = name;
      });

      // 2. Define Columns
      worksheet.columns = [
        { header: 'Item Code', key: 'itemCode', width: 20 },
        { header: 'Item Description', key: 'itemDescription', width: 35 },
        { header: 'UOM (Base)', key: 'uomName', width: 15 },
        { header: 'UOM (Purchase)', key: 'purchaseUomName', width: 15 },
        { header: 'UOM (Sales)', key: 'salesUomName', width: 15 },
        { header: 'Brand', key: 'brandName', width: 20 },
        { header: 'Category', key: 'categoryName', width: 20 },
        { header: 'Sales', key: 'salesAccountName', width: 35 },
        { header: 'Sales Return', key: 'salesReturnAccountName', width: 35 },
        { header: 'Sales Discount', key: 'salesDiscountAccountName', width: 35 },
        { header: 'Cost of Goods Account', key: 'costOfGoodsAccountName', width: 35 },
        { header: 'Inventory Account', key: 'inventoryAccountName', width: 35 },
        { header: 'Purchase Account', key: 'purchaseAccountName', width: 35 },
      ];

      // 3. Add Data Rows and Apply Dynamic Search Dropdowns (Rows 2 to 1000)
      // We loop through rows to apply the formula individually per row
      const maxRows = Math.max(data.length + 1, 100); // Adjust range as needed

      data.forEach((item, index) => {
        worksheet.addRow({
          itemCode: item.itemCode || "",
          itemDescription: item.itemDescription || "",
          uomName: item.uomName || "",
          purchaseUomName: item.purchaseUomName || "",
          salesUomName: item.salesUomName || "",
          brandName: item.brandName || "",
          categoryName: item.categoryName || "",
          salesAccountName: item.salesAccountName || "",
          salesReturnAccountName: item.salesReturnAccountName || "",
          salesDiscountAccountName: item.salesDiscountAccountName || "",
          costOfGoodsAccountName: item.costOfGoodsAccountName || "",
          inventoryAccountName: item.inventoryAccountName || "",
          purchaseAccountName: item.purchaseAccountName || "",
        });
      });

      for (let r = 2; r <= maxRows; r++) {
        const dropdownColumns = [
          { col: 'H', index: 8 }, 
          { col: 'I', index: 9 }, 
          { col: 'J', index: 10 }, 
          { col: 'K', index: 11 },
          { col: 'L', index: 12 },
          { col: 'M', index: 13 },
        ];

        dropdownColumns.forEach(({ col }) => {
          worksheet.getCell(`${col}${r}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            // --- THE WORKING DYNAMIC SEARCH FORMULA ---
            formulae: [`=OFFSET(Account_Data!$A$1,MATCH(${col}${r}&"*",Account_Data!$A:$A,0)-1,0,COUNTIF(Account_Data!$A:$A,${col}${r}&"*"),1)`],
            showErrorMessage: false, // Prevents errors when typing partial text
            showInputMessage: true,
            promptTitle: 'Searchable Field',
            prompt: 'Type text to filter the dropdown list.'
          };
        });
      }

      // 4. Style the Header Row
      const headerRow = worksheet.getRow(1);
      headerRow.height = 30;
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF3B82F6' },
        };
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, size: 11 };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 5. Style Data Cells
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          row.height = 22;
          row.eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'left', indent: 1 };
            cell.border = {
              bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
              left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
              right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
            };
            
            // Use a specific color for account columns
            if ([8, 9, 10, 11, 12, 13].includes(cell.col)) {
              cell.font = { color: { argb: 'FF2563EB' }, name: 'Arial' }; 
            }
          });
        }
      });

      // 6. Finalize and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Inventory_Template_${new Date().toISOString().split('T')[0]}.xlsx`);

    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProcessImport = async (file) => {
    setLoading(true);

    try {
      // 1. We need the original account list to map "Names" back to "IDs"
      const accountsData = await fetchAccountsData();
      const accountMap = new Map(accountsData.map(acc => [acc.accountName, acc.id]));

      // 2. Load the Excel File
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet('Items List');

        const payload = [];

        // 3. Iterate through rows (Skip header row 1)
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            const itemCode = row.getCell(1).value?.toString().trim();
            if (!itemCode) return; // Skip if no Item Code

            // Extract Names from Excel
            const sales = row.getCell(8).value?.toString().trim();
            const returnName = row.getCell(9).value?.toString().trim();
            const discountName = row.getCell(10).value?.toString().trim();
            const cogsName = row.getCell(11).value?.toString().trim();
            const invName = row.getCell(12).value?.toString().trim();
            const purName = row.getCell(13).value?.toString().trim();

            // Construct the DTO for the C# backend
            payload.push({
              itemCode: itemCode,
              itemDescription: row.getCell(2).value?.toString() || "",
              uomName: row.getCell(3).value?.toString() || "",
              purchaseUomName: row.getCell(4).value?.toString() || "",
              salesUomName: row.getCell(5).value?.toString() || "",
              brandName: row.getCell(6).value?.toString() || "",
              categoryName: row.getCell(7).value?.toString() || "",
              // Map Name -> ID. If not found in the list, send null.
              salesAccountId: accountMap.get(sales) || null,
              salesReturnAccountId: accountMap.get(returnName) || null,
              salesDiscountAccountId: accountMap.get(discountName) || null,
              costOfGoodsAccountId: accountMap.get(cogsName) || null,
              inventoryAccountId: accountMap.get(invName) || null,
              purchaseAccountId: accountMap.get(purName) || null,
            });
          }
        });

        if (payload.length === 0) {
          alert("No valid data found in the file.");
          setLoading(false);
          return;
        }

        // 4. Send to Backend
        try {
          await axios.post(`${apiUrl}/api/Item/bulk`, payload);

          await fetchData();
          setSuccessMessage("Data added successfully!");
        } catch (error) {
          console.error('There was a problem adding data:', error);
          const errorMessage = JSON.parse(error.response.request.responseText).message;
          setFailMessage(`Failed to add data: ${errorMessage}`);
        } finally {
          setLoading(false);
        }
      };
    } catch (error) {
      console.error("Import failed:", error);
      setLoading(false);
    }
  };

//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasItems) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <InventoryIcon fontSize="large" className="text-theme-color" />
              {`Items (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">List of items.</p>
          </div>
          <div className="flex items-center gap-1">
            <button onClick={openImportForm} className="flex items-center gap-1.5 px-4 py-2 text-gray-500 hover:text-theme-color hover:bg-gray-100 rounded-md text-sm font-medium transition-all border">
              <PublishIcon sx={{ fontSize: 16 }} />
              Import
            </button>
            
            <div className="h-4 w-[1px] bg-gray-300 mx-1"></div> {/* Small divider */}
            
            <button onClick={handleExport} className="flex items-center gap-1.5 px-4 py-2 text-gray-500 hover:text-theme-color hover:bg-gray-100 rounded-md text-sm font-medium transition-all border">
              <FileDownloadIcon sx={{ fontSize: 16 }} />
              Export
            </button>

            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Item
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by description or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"Items"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        
        itemCode={itemCode} setItemCode={setItemCode}
        itemDescription={itemDescription} setItemDescription={setItemDescription}
        uomName={uomName} setUomName={setUomName}
        purchaseUomName={purchaseUomName} setPurchaseUomName={setPurchaseUomName}
        salesUomName={salesUomName} setSalesUomName={setSalesUomName}
        brandName={brandName} setBrandName={setBrandName}
        categoryName={categoryName} setCategoryName={setCategoryName}
        salesAccount={salesAccount} setSalesAccount={setSalesAccount}
        salesReturnAccount={salesReturnAccount} setSalesReturnAccount={setSalesReturnAccount}
        salesDiscountAccount={salesDiscountAccount} setSalesDiscountAccount={setSalesDiscountAccount}
        costOfGoodsAccount={costOfGoodsAccount} setCostOfGoodsAccount={setCostOfGoodsAccount}
        inventoryAccount={inventoryAccount} setInventoryAccount={setInventoryAccount}
        purchaseAccount={purchaseAccount} setPurchaseAccount={setPurchaseAccount}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        
        itemCode={itemCode} setItemCode={setItemCode}
        itemDescription={itemDescription} setItemDescription={setItemDescription}
        uomName={uomName} setUomName={setUomName}
        purchaseUomName={purchaseUomName} setPurchaseUomName={setPurchaseUomName}
        salesUomName={salesUomName} setSalesUomName={setSalesUomName}
        brandName={brandName} setBrandName={setBrandName}
        categoryName={categoryName} setCategoryName={setCategoryName}
        salesAccount={salesAccount} setSalesAccount={setSalesAccount}
        salesReturnAccount={salesReturnAccount} setSalesReturnAccount={setSalesReturnAccount}
        salesDiscountAccount={salesDiscountAccount} setSalesDiscountAccount={setSalesDiscountAccount}
        costOfGoodsAccount={costOfGoodsAccount} setCostOfGoodsAccount={setCostOfGoodsAccount}
        inventoryAccount={inventoryAccount} setInventoryAccount={setInventoryAccount}
        purchaseAccount={purchaseAccount} setPurchaseAccount={setPurchaseAccount}
      />

      <ImportModal 
        isOpen={showImportForm} 
        onClose={closeImportForm} 
        onImport={handleProcessImport} 
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}







//#region AddUpdate Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  data,
  itemCode, setItemCode,
  itemDescription, setItemDescription,
  uomName, setUomName,
  purchaseUomName, setPurchaseUomName,
  salesUomName, setSalesUomName,
  brandName, setBrandName,
  categoryName, setCategoryName,
  salesAccount, setSalesAccount,
  salesReturnAccount, setSalesReturnAccount,
  salesDiscountAccount, setSalesDiscountAccount,
  costOfGoodsAccount, setCostOfGoodsAccount,
  inventoryAccount, setInventoryAccount,
  purchaseAccount, setPurchaseAccount,
}) => {
  const [failMessage, setFailMessage] = useState("");

  const [showSalesSelectForm, setShowSalesSelectForm] = useState(false);
  const openSalesSelectForm = () => {
    setShowSalesSelectForm(true);
  }
  const closeSalesSelectForm = () => {
    setShowSalesSelectForm(false);
  }

  const [showSalesReturnSelectForm, setShowSalesReturnSelectForm] = useState(false);
  const openSalesReturnSelectForm = () => {
    setShowSalesReturnSelectForm(true);
  }
  const closeSalesReturnSelectForm = () => {
    setShowSalesReturnSelectForm(false);
  }

  const [showSalesDiscountSelectForm, setShowSalesDiscountSelectForm] = useState(false);
  const openSalesDiscountSelectForm = () => {
    setShowSalesDiscountSelectForm(true);
  }
  const closeSalesDiscountSelectForm = () => {
    setShowSalesDiscountSelectForm(false);
  }

  const [showCOGSelectForm, setShowCOGSelectForm] = useState(false);
  const openCOGSelectForm = () => {
    setShowCOGSelectForm(true);
  }
  const closeCOGSelectForm = () => {
    setShowCOGSelectForm(false);
  }

  const [showInventorySelectForm, setShowInventorySelectForm] = useState(false);
  const openInventorySelectForm = () => {
    setShowInventorySelectForm(true);
  }
  const closeInventorySelectForm = () => {
    setShowInventorySelectForm(false);
  }

  const [showPurchaseSelectForm, setShowPurchaseSelectForm] = useState(false);
  const openPurchaseSelectForm = () => {
    setShowPurchaseSelectForm(true);
  }
  const closePurchaseSelectForm = () => {
    setShowPurchaseSelectForm(false);
  }

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!itemCode) {
      setFailMessage("Please fill up required field/s.");
      return;
    }
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-4xl max-h-[90vh]  p-8 flex flex-col overflow-hidden"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>
              <div className="max-w-4xl mx-auto p-4 md:p-8 bg-white rounded-xl shadow-sm overflow-y-auto custom-scrollbar flex flex-col gap-5">
                
                {/* SECTION 1: BASIC INFORMATION */}
                <section className="mb-10">
                  <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
                    <InfoOutlinedIcon className="text-theme-color" fontSize="small" />
                    <h2 className="text-lg font-bold text-gray-800 tracking-tight">Basic Information</h2>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
                    {/* Item Code */}
                    <div className="space-y-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        Item Code <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. I-00001"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 placeholder-gray-400 focus:bg-white focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={itemCode}
                        onChange={(e) => setItemCode(e.target.value)}
                      />
                    </div>

                    {/* Description */}
                    <div className="space-y-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        Description
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. High-grade Plastic"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 placeholder-gray-400 focus:bg-white focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={itemDescription}
                        onChange={(e) => setItemDescription(e.target.value)}
                      />
                    </div>

                    {/* UOM */}
                    <div className="space-y-1.5">
                      <label className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        <StraightenOutlinedIcon sx={{ fontSize: 14 }} /> UOM (Base)
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. kg"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={uomName}
                        onChange={(e) => setUomName(e.target.value)}
                      />
                    </div>

                    <div className="space-y-1.5">
                      <label className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        <StraightenOutlinedIcon sx={{ fontSize: 14 }} /> UOM (Purchase)
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. kg"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={purchaseUomName}
                        onChange={(e) => setPurchaseUomName(e.target.value)}
                      />
                    </div>

                    <div className="space-y-1.5">
                      <label className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        <StraightenOutlinedIcon sx={{ fontSize: 14 }} /> UOM (Sales)
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. kg"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={salesUomName}
                        onChange={(e) => setSalesUomName(e.target.value)}
                      />
                    </div>

                    {/* Brand */}
                    <div className="space-y-1.5">
                      <label className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        <StyleOutlinedIcon sx={{ fontSize: 14 }} /> Brand
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. Brand A"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                      />
                    </div>

                    {/* Category */}
                    <div className="space-y-1.5 md:col-span-2">
                      <label className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
                        <CategoryOutlinedIcon sx={{ fontSize: 14 }} /> Category
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. Raw Materials"
                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:ring-2 focus:ring-theme-color/20 focus:border-theme-color outline-none transition-all"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                      />
                    </div>
                  </div>
                </section>

                {/* SECTION 2: ACCOUNTS SETUP */}
                <section className="mb-10">
                  <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
                    <AccountBalanceWalletOutlinedIcon className="text-theme-color" fontSize="small" />
                    <h2 className="text-lg font-bold text-gray-800 tracking-tight">Returns & Discounts</h2>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {[
                      { label: 'Sales Return', value: salesReturnAccount, open: openSalesReturnSelectForm, clear: () => setSalesReturnAccount(null) },
                      { label: 'Sales Discount', value: salesDiscountAccount, open: openSalesDiscountSelectForm, clear: () => setSalesDiscountAccount(null) },
                    ].map((account, idx) => (
                      <div key={idx} className="space-y-1.5">
                        <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">
                          {account.label} Account
                        </label>
                        <div className="relative flex items-center group">
                          <input
                            type="text"
                            placeholder="Not Selected"
                            className={`w-full text-sm rounded-lg pl-3 pr-10 py-2.5 border transition-all cursor-default focus:outline-none
                              ${account.value 
                                ? "bg-theme-color/5 border-theme-color/30 text-theme-color font-medium" 
                                : "bg-gray-50 border-gray-200 text-gray-400"
                              }`}
                            value={account.value?.accountName || ""}
                            readOnly
                          />
                          
                          <div className="absolute right-1 flex items-center">
                            {!account.value ? (
                              <button 
                                onClick={account.open}
                                className="p-1.5 text-gray-400 hover:text-theme-color hover:bg-theme-color/10 rounded-md transition-colors"
                                title="Search Account"
                              >
                                <ManageSearchIcon fontSize="small" />
                              </button>
                            ) : (
                              <button 
                                onClick={account.clear}
                                className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                                title="Remove Account"
                              >
                                <RemoveCircleIcon fontSize="small" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>

                <section>
                  <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
                    <AccountBalanceWalletOutlinedIcon className="text-theme-color" fontSize="small" />
                    <h2 className="text-lg font-bold text-gray-800 tracking-tight">Accounts Setup</h2>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {[
                      { label: 'Sales', value: salesAccount, open: openSalesSelectForm, clear: () => setSalesAccount(null) },
                      { label: 'Cost of Goods', value: costOfGoodsAccount, open: openCOGSelectForm, clear: () => setCostOfGoodsAccount(null) },
                      { label: 'Inventory', value: inventoryAccount, open: openInventorySelectForm, clear: () => setInventoryAccount(null) },
                      { label: 'Purchase', value: purchaseAccount, open: openPurchaseSelectForm, clear: () => setPurchaseAccount(null) }
                    ].map((account, idx) => (
                      <div key={idx} className="space-y-1.5">
                        <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">
                          {account.label} Account
                        </label>
                        <div className="relative flex items-center group">
                          <input
                            type="text"
                            placeholder="Not Selected"
                            className={`w-full text-sm rounded-lg pl-3 pr-10 py-2.5 border transition-all cursor-default focus:outline-none
                              ${account.value 
                                ? "bg-theme-color/5 border-theme-color/30 text-theme-color font-medium" 
                                : "bg-gray-50 border-gray-200 text-gray-400"
                              }`}
                            value={account.value?.accountName || ""}
                            readOnly
                          />
                          
                          <div className="absolute right-1 flex items-center">
                            {!account.value ? (
                              <button 
                                onClick={account.open}
                                className="p-1.5 text-gray-400 hover:text-theme-color hover:bg-theme-color/10 rounded-md transition-colors"
                                title="Search Account"
                              >
                                <ManageSearchIcon fontSize="small" />
                              </button>
                            ) : (
                              <button 
                                onClick={account.clear}
                                className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                                title="Remove Account"
                              >
                                <RemoveCircleIcon fontSize="small" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <ChartOfAccountsSelect 
        visible={showSalesSelectForm} 
        onClose={closeSalesSelectForm}
        modalName={"Select Sales Account"}
        data={salesAccount} setData={setSalesAccount}
      />

      <ChartOfAccountsSelect 
        visible={showSalesReturnSelectForm} 
        onClose={closeSalesReturnSelectForm}
        modalName={"Select Sales Return Account"}
        data={salesReturnAccount} setData={setSalesReturnAccount}
      />

      <ChartOfAccountsSelect 
        visible={showSalesDiscountSelectForm} 
        onClose={closeSalesDiscountSelectForm}
        modalName={"Select Sales Discount Account"}
        data={salesDiscountAccount} setData={setSalesDiscountAccount}
      />

      <ChartOfAccountsSelect 
        visible={showCOGSelectForm} 
        onClose={closeCOGSelectForm}
        modalName={"Select Cost of Good Account"}
        data={costOfGoodsAccount} setData={setCostOfGoodsAccount}
      />

      <ChartOfAccountsSelect 
        visible={showInventorySelectForm} 
        onClose={closeInventorySelectForm}
        modalName={"Select Inventory Account"}
        data={inventoryAccount} setData={setInventoryAccount}
      />

      <ChartOfAccountsSelect 
        visible={showPurchaseSelectForm} 
        onClose={closePurchaseSelectForm}
        modalName={"Select Purchase Account"}
        data={purchaseAccount} setData={setPurchaseAccount}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion





//#region Import Modal
const ImportModal = ({ isOpen, onClose, onImport }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState([]); // Store rows for preview
  const [isDragging, setIsDragging] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const fileInputRef = useRef(null);

  if (!isOpen) return null;

  // Function to read the Excel file and generate a preview
  const generatePreview = async (selectedFile) => {
    setLoadingPreview(true);
    try {
      const reader = new FileReader();
      reader.readAsArrayBuffer(selectedFile);
      reader.onload = async (e) => {
        const buffer = e.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet("Items List") || workbook.worksheets[0];

        const rows = [];
        // Read only the first 6 rows (Header + 5 data rows) for preview
        worksheet.eachRow((row) => {
          if(row.number > 1){
            rows.push({
              itemCode: row.getCell(1).value?.toString() || "",
              itemDescription: row.getCell(2).value?.toString() || "",
              uomName: row.getCell(3).value?.toString() || "",
              purchaseUomName: row.getCell(4).value?.toString() || "",
              salesUomName: row.getCell(5).value?.toString() || "",
              brandName: row.getCell(6).value?.toString() || "",
              categoryName: row.getCell(7).value?.toString() || "",
              salesAccount: row.getCell(8).value?.toString() || "",
              salesReturnAccount: row.getCell(9).value?.toString() || "",
              salesDiscountAccount: row.getCell(10).value?.toString() || "",
              costOfGoodsAccount: row.getCell(11).value?.toString() || "",
              inventoryAccount: row.getCell(12).value?.toString() || "",
              purchaseAccount: row.getCell(13).value?.toString() || "",
            });
          }
        });
        setPreviewData(rows);
        setLoadingPreview(false);
      };
    } catch (error) {
      console.error("Preview failed", error);
      setLoadingPreview(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      generatePreview(selectedFile);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      generatePreview(droppedFile);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setFile(null);
    setPreviewData([]);
  };

  const handleUpload = () => {
    if (file) {
      onImport(file);
      setFile(null);
      setPreviewData([]);
      onClose();
    }
  };

  const handleClose = (e) => {
    onClose()
    handleRemove(e)
    setCurrentPage(1)
  }

  const headers = [
    'Item Code', 
    'Item Description', 
    'UOM (Base)', 
    'UOM (Purchase)', 
    'UOM (Sales)', 
    'Brand', 
    'Category', 
    'Sales Return Account', 
    'Sales Discount Account', 
    'COGS Account', 
    'Inventory Account', 
    'Purchase Account', 
  ]
  const accessors = [
    'itemCode', 
    'itemDescription', 
    'uomName', 
    'purchaseUomName', 
    'salesUomName', 
    'brandName', 
    'categoryName', 
    'salesReturnAccount', 
    'salesDiscountAccount', 
    'costOfGoodsAccount', 
    'inventoryAccount', 
    'purchaseAccount', 
  ]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[90vh]">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
          <h2 className="text-lg font-semibold text-gray-800">Import Items</h2>
          <button onClick={handleClose} className="text-gray-400 hover:text-gray-600">
            <CloseIcon size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto">
          {!file ? (
            <div
              onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
              className={`border-2 border-dashed rounded-lg p-12 flex flex-col items-center justify-center cursor-pointer transition-all ${
                isDragging ? "border-blue-500 bg-blue-50" : "border-gray-300 hover:border-blue-400"
              }`}
            >
              <input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".xlsx, .xls" className="hidden" />
              <div className="bg-blue-100 p-3 rounded-full text-blue-600 mb-4">
                <FileUploadIcon size={28} />
              </div>
              <p className="text-gray-700 font-medium">Please select file or drop down file</p>
              <p className="text-gray-400 text-sm mt-1">Excel templates only (.xlsx)</p>
            </div>
          ) : (
            <div className="space-y-4">
              {/* File Info Card */}
              <div className="flex items-center justify-between bg-blue-50 border border-blue-100 p-4 rounded-lg">
                <div className="flex items-center gap-3">
                  <FileCopyIcon className="text-blue-600" size={24} />
                  <div>
                    <p className="text-blue-900 font-semibold text-sm">{file.name}</p>
                    <p className="text-blue-700 text-xs">{(file.size / 1024).toFixed(2)} KB</p>
                  </div>
                </div>
                <button onClick={handleRemove} className="text-red-500 text-sm font-medium hover:underline">Change File</button>
              </div>

              {/* Preview Table */}
              <div>
                <div className="flex items-center gap-2 mb-2 text-gray-600">
                  <PreviewIcon size={16} />
                  <span className="text-xs font-bold uppercase tracking-wider">Data Preview</span>
                </div>
                
                {loadingPreview ? (
                  <div className="h-32 flex items-center justify-center text-gray-400">Loading preview...</div>
                ) : (
                  <div className="border rounded-lg overflow-x-auto bg-gray-50">
                    <table className="min-w-full divide-y divide-gray-200 text-[11px] hidden">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Item Code</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Description</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">UOM (Base)</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">UOM (Purchase)</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">UOM (Sales)</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Brand</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Category</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">COGS Account</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Inventory Account</th>
                          <th className="px-3 py-2 text-left font-bold text-gray-600">Purchase Account</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {previewData.slice(1).map((row, i) => (
                          <tr key={i}>
                            <td className="px-3 py-2 whitespace-nowrap text-gray-700">{row.itemCode}</td>
                            <td className="px-3 py-2 text-gray-500 truncate max-w-[150px]">{row.itemDescription}</td>
                            <td className="px-3 py-2 text-gray-500">{row.uomName}</td>
                            <td className="px-3 py-2 text-gray-500">{row.purchaseUomName}</td>
                            <td className="px-3 py-2 text-gray-500">{row.salesUomName}</td>
                            <td className="px-3 py-2 text-gray-500">{row.brandName}</td>
                            <td className="px-3 py-2 text-gray-500">{row.categoryName}</td>
                            <td className="px-3 py-2 text-blue-600 font-medium">{row.costOfGoodsAccount}</td>
                            <td className="px-3 py-2 text-blue-600 font-medium">{row.inventoryAccount}</td>
                            <td className="px-3 py-2 text-blue-600 font-medium">{row.purchaseAccount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <CreateTable
                      tableName={"Items"}
                      headers={headers}
                      accessors={accessors}
                      data={previewData}
                      actions={[]}

                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      itemsPerPage={10}
                      totalItems={previewData?.length}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t flex justify-end gap-3">
          <button onClick={handleClose} className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800">Cancel</button>
          <button
            onClick={handleUpload}
            disabled={!file || loadingPreview}
            className={`px-6 py-2 rounded-lg text-sm font-bold text-white transition-all ${
              file ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            Import Now
          </button>
        </div>
      </div>
    </div>
  );
};
//#endregion